import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable} from 'rxjs';
import {ApiService} from './api.service';
import {Flats} from '../models/flats.model';
import {CrudUtilities} from '../util/crud-utilities';
import {Flat} from '../models/flat.model';
import {map} from 'rxjs/operators';

@Injectable()
export class FlatManagerService {


  public flatsSubject = new BehaviorSubject<Flats>(new Flats());
  public flats = this.flatsSubject.asObservable();

  public selectedFlatSubject = new BehaviorSubject<Flat>(new Flat());
  public selectedFlat = this.selectedFlatSubject.asObservable();


  constructor(private apiService: ApiService, public crudUtils: CrudUtilities) {

  }

  setFlatList(flats: Flats) {
    this.flatsSubject.next(flats);
  }

  createFlat(flat: Flat) {
    return this.apiService.post('flats.json', flat).subscribe((response) => {

      if (response.name) {
        flat.id = response.name;
        this.selectedFlatSubject.next({...flat});
        this.crudUtils.addNewItemToList(this.flatsSubject, flat);
      }
    });
  }

  editFlat(flat: Flat) {
    return this.apiService
      .patch(`flats/${flat.id}.json`, flat).subscribe((response: Flat) => {
        this.selectedFlatSubject.next({...response});
        this.crudUtils.editListItem(this.flatsSubject, response);
      });
  }

  deleteFlat(flat, dialogRef) {
    return this.apiService.delete(`flats/${flat.id}.json`).subscribe(() => {
      this.crudUtils.deleteListItem(this.flatsSubject, flat);
      dialogRef.close();

    });
  }

  getFlats() {
    return this.apiService.get('flats.json').pipe(map((response) => {

      let list: Flat[] = [];
      for (let key in response) {
        response[key].id = key;
        list.push(response[key]);
      }
      return list;
    }));
  }


  getFlatsAndSave() {
    this.getFlats().subscribe((list) => {
      this.flatsSubject.next({items: list});
    });
  }


  getFlat(id): Observable<any> {
    return this.apiService.get('flats/' + id + '.json');
  }


}
